import { useContext } from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import MenuItemShareModal from '@ecosystems/MenuItemShareModal';
import LanguageContext from '@lib/contexts/languageContext';
import Icon from '@components/Icon';
import {
  Popover,
  PopoverContent,
  PopoverItem,
  PopoverTrigger,
} from 'src/ui/popover';

const Wrapper = styled.div``;

const Trigger = styled(PopoverTrigger)`
  display: flex;
  align-items: center;
  border: none;
  border-radius: 5px;
  padding: 12px 0px;
  background: none;
  cursor: pointer;

  [name='ygb-icon-menu-hor'] {
    transform: rotate(90deg);

    :before {
      color: ${({ theme }) => theme.colors.neutrals['gray']};
    }
  }
`;

const ProgramMenu = ({
  className = '',
  programCategory,
  programId,
  enableGiftPurchase = false,
  canExtendAccess = true,
  disablePurchases = false,
}) => {
  const lang = useContext(LanguageContext);

  return (
    <Wrapper className={className}>
      <Popover>
        <Trigger className="bg-none">
          <Icon name="ygb-icon-menu-hor" fontSize="5px" />
        </Trigger>
        <PopoverContent>
          {!disablePurchases
            ? [
                enableGiftPurchase ? (
                  <PopoverItem
                    key="0"
                    href={`/${lang}/${programCategory}/${programId}/buy-gift`}
                  >
                    <Trans id="programs_2021.header.buy_as_gift" />
                  </PopoverItem>
                ) : null,
                canExtendAccess ? (
                  <PopoverItem
                    key="1"
                    href={`/${lang}/${programCategory}/${programId}/get-started`}
                  >
                    <Trans id="programs_2021.header.extend_access" />
                  </PopoverItem>
                ) : null,
              ]
            : null}
          <MenuItemShareModal
            resource={programCategory}
            shareURL={`${process.env.DOMAIN}/${lang}/${programCategory}/${programId}/overview`}
          />
        </PopoverContent>
      </Popover>
    </Wrapper>
  );
};

export default ProgramMenu;
